<template>
	<div class="site-header">
		<div class="header-inner">
			<!-- 左侧Logo+导航 -->
			<div class="nav-left">
				<div class="nav-list">
					<span class="nav-item" :class="{ active: currentRoute === 'indexHome' }" @click="navigateTo('indexHome')">{{ $t('header.nav.home') }}</span>
					<span class="nav-item" :class="{ active: currentRoute === 'logisticsQuery' }" @click="navigateTo('logisticsQuery')">{{ $t('header.nav.logisticsQuery') }}</span>
					<span class="nav-item" :class="{ active: currentRoute === 'shopIndex'||currentRoute === 'shopCat' }" @click="navigateTo('shopIndex')">{{ $t('header.nav.shopIndex') }}</span>
					<span class="nav-item" :class="{ active: currentRoute === 'freightEstimate'||currentRoute === 'freightDetail' }" @click="navigateTo('freightEstimate')">{{ $t('header.nav.freightEstimate') }}</span>
					<span class="nav-item" :class="{ active: currentRoute === 'mainBusiness' }" @click="navigateTo('mainBusiness')">{{ $t('header.nav.mainBusiness') }}</span>
					<span class="nav-item" :class="{ active: currentRoute === 'latestNews' }" @click="navigateTo('latestNews')">{{ $t('header.nav.latestNews') }}</span>
					<span class="nav-item" @click="link('/userPageLab/faq')">{{ $t('header.nav.faq') }}</span>
					<span class="nav-item" @click="openContactDialog">{{ $t('header.nav.aboutUs') }}</span>
				</div>
			</div>
			<!-- 右侧用户区 -->
			<div class="nav-right">
				<div class="lang-btn" @click.stop="toggleLangMenu">
					<span>{{ currentLangLabel }}</span>
					<el-image :src="require('@/static/CodeBuddyAssets/31120_1115/27.svg')"></el-image>
					<!-- 语言下拉菜单 -->
					<transition
					name="lang-dropdown"
					@before-enter="onAnimStart"
					@after-enter="onAnimEnd"
					@before-leave="onAnimStart"
					@after-leave="onAnimEnd">
						<div v-show="showLangMenu" class="lang-dropdown">
							<div
							v-for="item in langArr"
							:key="item"
							class="lang-option"
							:class="{ active: $i18n.locale === item }"
							@click.stop="selectLanguage(item)"
							>{{ item === 'zh' ? $t('lanZhTxt') : $t('lanEnTxt') }}</div>
						</div>
					</transition>
				</div>
				<el-image class="divider-v" :src="require('@/static/CodeBuddyAssets/31120_1115/29.svg')"></el-image>
				<div class="user-info" v-if="!(userInfo)" @click="link('/login')">
					<span>{{ $t('login') }}</span>
				</div>
				<div class="user-info" v-if="userInfo" @click="goToUserCenter">
					<!-- {{userInfo}}1 -->
					<el-image class="avatar" :src="userInfo.portrait"></el-image>
					<span>{{ userInfo.name }}</span>
				</div>
				<el-image class="divider-v" v-if="userInfo" :src="require('@/static/CodeBuddyAssets/31120_1115/28.svg')"></el-image>
				<span class="logout-btn" v-if="userInfo" @click="handleLogout">{{ $t('header.logout') }}</span>
			</div>
		</div>

		<!-- ====== 联系我们弹窗 ====== -->
		<el-dialog
			:visible.sync="contactDialogVisible"
			width="5.84rem"
			custom-class="contact-dialog"
			:show-close="false"
			:close-on-click-modal="true"
			:append-to-body="true"
			:modal-append-to-body="true">
			
			<!-- 弹窗内容 -->
			<div class="contact-modal">
				<!-- 头部区域（标题 + 关闭按钮） -->
				<div class="modal-header-bg">
					<el-image
						class="modal-close-btn"
						style="opacity: 0;"
						:src="require('@/static/CodeBuddyAssets/32719_3658/1.svg')">
					</el-image>
					<h3 class="modal-title">{{ $t('footer.contact.btnText') }}</h3>
					<el-image 
						class="modal-close-btn"
						:src="require('@/static/CodeBuddyAssets/32719_3658/1.svg')"
						@click="closeContactDialog">
					</el-image>
				</div>

				<!-- 公司信息区域 -->
				<div class="company-info">
					<h4 class="company-name-cn">{{pzMsg.companyName}}</h4>
					<p class="company-name-en">{{pzMsg.companyNameEn}}</p>
					
					<!-- 地址 -->
					<div class="info-row">
						<el-image 
							class="info-icon"
							:src="require('@/static/CodeBuddyAssets/32719_3658/2.svg')">
						</el-image>
						<span class="info-text">{{pzMsg.companyAddress}}</span>
					</div>
					
					<!-- 国内电话 -->
					<div class="info-row info-row--phone">
						<el-image 
							class="info-icon"
							:src="require('@/static/CodeBuddyAssets/32719_3658/3.svg')">
						</el-image>
						<span class="info-text">{{ $t('footer.contact.btnText1') }}：{{pzMsg.chinaPhoneNumber}}</span>
					</div>
					
					<!-- 国际电话 -->
					<div class="info-row info-row--phone">
						<el-image 
							class="info-icon"
							:src="require('@/static/CodeBuddyAssets/32719_3658/4.svg')">
						</el-image>
						<span class="info-text">{{ $t('footer.contact.btnText2') }}：{{pzMsg.foreignPhoneNumber}}</span>
					</div>
				</div>

				<!-- 二维码区域 -->
				<div class="qrcode-section">
					<!-- 微信二维码 -->
					<div class="qrcode-item">
						<el-image 
							class="qrcode-img"
							:src="pzMsg.wechatQrCode"
							:preview-src-list="[pzMsg.wechatQrCode]">
						</el-image>
						<p class="qrcode-label">{{ $t('footer.contact.btnText3') }}</p>
						<p class="qrcode-id">{{pzMsg.wechat}}</p>
					</div>
					
					<!-- WhatsApp二维码 -->
					<div class="qrcode-item">
						<el-image 
							class="qrcode-img"
							:src="pzMsg.whatsappQrCode"
							:preview-src-list="[pzMsg.whatsappQrCode]">
						</el-image>
						<p class="qrcode-label">WhatsAPP</p>
						<p class="qrcode-id">{{pzMsg.whatsapp}}</p>
					</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import {
	configbase
} from "/src/api/api.js"
export default {
	name: 'SiteHeader',
	// 组件响应式数据
	data() {
		return {
			// 支持的语言列表：中文、英文
			langArr: ['zh', 'en'],
			// 控制语言下拉菜单的显示与隐藏
			showLangMenu: false,
			// 动画执行锁，防止动画期间重复触发交互
			isAnimating: false,
			// 联系我们弹窗控制
			contactDialogVisible: false,
			pzMsg: '',
		}
	},
	computed: {
		// 获取当前路由名称（去掉路径前缀的 /）
		currentRoute() {
			const path = this.$route.path
			return path.replace(/^\//, '')
		},
		// 根据当前语言设置返回对应的语言标签文本（中文/English）
		currentLangLabel() {
			return this.$i18n.locale === 'zh' ? this.$t('lanZhTxt') : this.$t('lanEnTxt')
		}
	},
	methods: {
		// 切换语言下拉菜单的展开/收起状态（动画期间不可触发）
		toggleLangMenu() {
			if (this.isAnimating) return
			this.showLangMenu = !this.showLangMenu
		},
		// 过渡动画开始时的回调，锁定动画状态以阻止重复操作
		onAnimStart() {
			this.isAnimating = true
		},
		// 过渡动画结束后的回调，解除动画锁定状态
		onAnimEnd() {
			this.isAnimating = false
		},
		// 用户选择某一项语言后调用：切换语言并关闭下拉菜单
		selectLanguage(lang) {
			this.changeLanguage(lang)
			this.showLangMenu = false
		},
		// 执行语言切换核心逻辑，通过修改 i18n 的 locale 实现中英文切换
		changeLanguage(lang) {
			this.$i18n.locale = lang
			localStorage.setItem('lang', lang);
		},
		// 页面导航跳转，避免重复跳转到当前页面
		navigateTo(route) {
			if (this.currentRoute !== route) {
				this.$router.push('/' + route)
			}
		},
		// 关闭语言下拉菜单，供点击页面外部区域时调用
		closeLangMenu() {
			this.showLangMenu = false
		},
		goToUserCenter() {
			this.$router.push('/userPageLab/userCenter')
		},
		// 退出登录
		async handleLogout() {
			try {
				await this.$confirm(this.$t('confirmDialog.logoutMsg'), this.$t('confirmDialog.logoutTitle'), {
					confirmButtonText: this.$t('confirmDialog.confirmBtn'),
					cancelButtonText: this.$t('confirmDialog.cancelBtn'),
					type: 'warning'
				})
				this.$store.commit('userMsg/tokenC', '')
				this.$store.commit('userMsg/userInfoC', '')
				this.$router.push('/login')
			} catch (err) {
				if (err !== 'cancel') {
					console.error(this.$t('confirmDialog.logoutErr'), err)
				}
			}
		},
		// 配置信息
		async configbase(){
			var res;
			res = await configbase({});
			if(res.code==200){
				this.pzMsg = res.data
			}else{this.Tips(res.msg,'error')}
		},
		openContactDialog() {
			this.contactDialogVisible = true;
		},
		closeContactDialog() {
			this.contactDialogVisible = false;
		}
	},
	// 组件挂载完成后注册全局点击事件监听，用于点击外部区域自动收起语言菜单
	mounted() {
		document.addEventListener('click', this.closeLangMenu)
		this.configbase()
	},
	// 组件销毁前移除全局点击事件监听，防止内存泄漏
	beforeDestroy() {
		document.removeEventListener('click', this.closeLangMenu)
	},
}
</script>

<style lang="scss" scoped>
.site-header {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	z-index: 20;
}
.header-inner {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0.22rem 0.90rem 0 0.90rem;
	height: 0.80rem;
}
.nav-left {
	display: flex;
	align-items: center;
}
.logo-wrap {
	margin-right: 0.10rem;
	.logo {
		display: block;
	}
}
.nav-list {
	display: flex;
	align-items: center;
	.nav-item {
		color: rgba(255, 255, 255, 0.85);
		font-size: 0.16rem;
		font-weight: 500;
		cursor: pointer;
		padding: 0 0.12rem;
		line-height: 0.34rem;
		transition: color 0.3s;
		margin-right: 0.24rem;
		&:hover {
			color: #fff;
		}
		&.active {
			color: #fff;
			position: relative;
			&::after {
				content: '';
				position: absolute;
				bottom: -0.04rem;
				left: 50%;
				transform: translateX(-50%);
				width: 0.20rem;
				height: 0.02rem;
				background: #fff;
				border-radius: 0.01rem;
			}
		}
	}
}
.nav-right {
	display: flex;
	align-items: center;
	.lang-btn {
		position: relative;
		color: #fff;
		font-size: 0.16rem;
		font-weight: 500;
		cursor: pointer;
		display: flex;
		align-items: center;
		img, .el-image {
			margin-left: 0.04rem;
		}
		.lang-dropdown {
			position: absolute;
			top: 100%;
			left: 0;
			margin-top: 0.08rem;
			background: #fff;
			border-radius: 0.06rem;
			box-shadow: 0 0.04rem 0.12rem rgba(0, 0, 0, 0.15);
			overflow: hidden;
			z-index: 20;
			min-width: 1.20rem;
		}

		/* ========== 语言下拉菜单动效：淡入淡出 + 向下滑出 ========== */
		.lang-dropdown-enter-active,
		.lang-dropdown-leave-active {
			transition: opacity 0.25s cubic-bezier(0.4, 0, 0.2, 1),
			            transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
			transform-origin: top center;
		}
		.lang-dropdown-enter,
		.lang-dropdown-leave-to {
			opacity: 0;
			transform: scaleY(0.92) translateY(-0.04rem);
		}
		/* 减少动态偏好：禁用动画 */
		@media (prefers-reduced-motion: reduce) {
			.lang-dropdown-enter-active,
			.lang-dropdown-leave-active {
				transition: none;
			}
			.lang-dropdown-enter,
			.lang-dropdown-leave-to {
				opacity: 1;
				transform: none;
			}
		}
		.lang-option {
			padding: 0.10rem 0.16rem;
			font-size: 0.14rem;
			color: #333;
			cursor: pointer;
			transition: background-color 0.2s, color 0.2s;
			&:hover {
				background: #f5f7fa;
				color: #0096FF;
			}
			&.active {
				color: #0096FF;
				font-weight: 600;
			}
		}
	}
	.divider-v {
		margin: 0 0.24rem;
	}
	.user-info {
		display: flex;
		align-items: center;
		cursor: pointer;
		.avatar {
			width: 38px;
			height: 38px;
			border-radius: 50%;
			border: 2px solid #fff;
			margin-right: 0.12rem;
		}
		span {
			color: #fff;
			font-size: 0.16rem;
			font-weight: 500;
		}
	}
	.logout-btn {
		color: #fff;
		font-size: 0.16rem;
		font-weight: 500;
		cursor: pointer;
		transition: opacity 0.3s;
		&:hover {
			opacity: 0.8;
		}
	}
}

/* ============================================================
   联系我们弹窗样式 (基于 Figma 设计 - 无定位属性)
   ============================================================ */
.contact-modal {
	background: white;
	border-radius: 10px;
	box-sizing: border-box;
	padding: 3px;
}

/* 头部区域（渐变背景 + 标题 + 关闭按钮） */
.modal-header-bg {
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 66px;
	background: linear-gradient(180deg, #E4F4FF 0%, white 100%);
	border-top-left-radius: 10px;
	border-top-right-radius: 10px;
	padding: 0 16px;
}

/* 标题 */
.modal-title {
	font-size: 22px;
	font-family: 'PingFang SC', sans-serif;
	font-weight: 500;
	color: #2F3541;
	margin: 0;
	white-space: nowrap;
}

/* 关闭按钮 */
.modal-close-btn {
	width: 20px;
	height: 20px;
	cursor: pointer;
	flex-shrink: 0;
	transition: opacity 0.3s;
	&:hover {
		opacity: 0.7;
	}
}

/* 公司信息区域 */
.company-info {
	padding: 20px 60px;
}

.company-name-cn {
	font-size: 24px;
	font-family: 'PingFang SC', sans-serif;
	font-weight: 500;
	color: #333333;
	white-space: nowrap;
	text-align: center;
	margin-bottom: 10px;
}

.company-name-en {
	font-size: 14px;
	font-family: 'PingFang SC', sans-serif;
	font-weight: 400;
	color: #CBCBCB;
	white-space: nowrap;
	text-align: center;
	margin-bottom: 26px;
}

/* 信息行（地址、电话） */
.info-row {
	display: flex;
	align-items: center;
	height: 22px;
	margin-bottom: 24px;
	&:last-child{
		margin-bottom: 10px;
	}
	
	.info-icon {
		width: 18px;
		height: 18px;
		flex-shrink: 0;
	}
	
	.info-text {
		margin-left: 8px;
		font-size: 16px;
		font-family: 'PingFang SC', sans-serif;
		font-weight: 400;
		color: #7C8388;
		white-space: nowrap;
	}
}

.info-row--phone {
	width: auto;
}

/* 二维码区域 */
.qrcode-section {
	display: flex;
	justify-content: center;
	align-items: flex-start;
	padding: 30px 0 20px;
	padding-top: 10px;
}

.qrcode-item {
	width: 158px;
	text-align: center;
	margin: 0 21px;
	
	.qrcode-img {
		width: 158px;
		height: 158px;
		cursor: pointer;
		display: block;
		border: 1px solid #eee;
		margin-bottom: 10px;
	}
	
	.qrcode-label {
		font-size: 16px;
		font-family: 'PingFang SC', sans-serif;
		font-weight: 400;
		color: #333333;
		margin: 8px 0 4px;
	}
	
	.qrcode-id {
		font-size: 18px;
		font-family: 'PingFang SC', sans-serif;
		font-weight: 400;
		color: #0096FF;
		margin: 0;
	}
}
</style>

<!-- 全局样式：覆盖 el-dialog 默认样式 -->
<style lang="scss">
.contact-dialog {
	border-radius: 10px !important;
	overflow: visible;
	box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
	
	.el-dialog__header {
		display: none;
		padding: 0;
		margin: 0;
	}
	
	.el-dialog__body {
		padding: 6px;
	}
	
	.el-dialog__footer {
		display: none;
		padding: 0;
		margin: 0;
	}
}
</style>
